import { getSiteLocalization } from '@/lib/i18n/config/site-locales'

export function formatNumber(amount: number, locale = getSiteLocalization().locale): string {
  return new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount)
}

export function roundTo(value: number, decimals = 2): number {
  const factor = 10 ** decimals

  return Math.round(value * factor) / factor
}

export function convertMbToBytes(mb: number): number {
  return mb * 1000 * 1000
}

export function convertBytesToMb(bytes: number): number {
  return bytes / (1000 * 1000)
}

export function convertBytesToKb(bytes: number): number {
  return bytes / 1000
}
